import { SentimentQualification } from '../models/sentiment.model';

const BASE = 'interchain-dashboard.qualification-texts';

export function getSentimentQualification(
  score: number | null | undefined,
  mentions: number | null | undefined,
): SentimentQualification {
  // El backend devuelve índice 0 también cuando el período no tiene menciones.
  if (score == null || Number.isNaN(score) || mentions === 0) return 'no-data';
  if (score > 90) return 'excellent';
  if (score >= 80) return 'good';
  if (score >= 70) return 'regular';
  if (score >= 60) return 'bad';
  return 'very-bad';
}

export function getSentimentQualificationKey(
  score: number | null | undefined,
  mentions: number | null | undefined,
): string {
  return `${BASE}.${getSentimentQualification(score, mentions)}`;
}

export function getSentimentQualificationDescriptionKey(
  score: number | null | undefined,
  mentions: number | null | undefined,
): string {
  return `${BASE}.${getSentimentQualification(score, mentions)}-description-individual`;
}

/**
 * Escala de 3 tramos usada en las filas de las listas. Se mantiene separada de la
 * escala de 5 tramos a propósito: con cinco colores las listas resultan ruidosas.
 */
export function getScoreToneClass(score: number): string {
  if (score >= 70) return 'tw-text-qualifications-excellent';
  if (score >= 40) return 'tw-text-amber-600';
  return 'tw-text-red-600';
}
